// const customSelectStyles = {
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? "#ef4444"
//       : state.isFocused
//       ? "#fdecea"
//       : "white",
//     color: state.isSelected ? "white" : "#111827",
//     cursor: "pointer",
//     ":active": {
//       backgroundColor: "#ef4444",
//       color: "white",
//     },
//     whiteSpace: "nowrap",
//   }),

//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: "white",
//     borderColor: state.isFocused ? "#9ca3af" : "#d1d5db", // SAME AS INPUT
//     boxShadow: "none",
//     borderWidth: "1px",
//     borderRadius: "6px", // SAME AS INPUT
//     minHeight: "42px",
//     height: "42px",

//     "&:hover": {
//       borderColor: "#9ca3af", // SAME HOVER COLOR AS INPUT
//     },
//   }),

//   valueContainer: (provided) => ({
//     ...provided,
//     height: "42px",
//     padding: "0 10px", // MATCH INPUT PADDING
//   }),

//   input: (provided) => ({
//     ...provided,
//     margin: 0,
//     padding: 0,
//   }),

//   container: (provided) => ({
//     ...provided,
//     width: "100%", // FIX: full width giống Input
//   }),

//   singleValue: (provided) => ({
//     ...provided,
//     color: "#111827",
//     fontSize: "0.875rem", // text-sm (Input)
//   }),

//   menu: (provided) => ({
//     ...provided,
//     zIndex: 9999,
//     minWidth: "100%",
//     maxWidth: "400px",
//     overflowX: "auto",
//   }),

//   // 🔴 QUAN TRỌNG: fix dropdown bị che trong Modal
//   menuPortal: (base) => ({
//     ...base,
//     zIndex: 99999,
//   }),
// };

// export default customSelectStyles;




// utils/customSelectStyles.js

// const customSelectStyles = {
//   // 1. Tùy chỉnh khung điều khiển (ô hiển thị chính)
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: "#f9fafb", // bg-gray-50 giống các input mới
//     borderColor: "transparent",
//     borderWidth: "2px",
//     borderRadius: "1rem", // rounded-2xl đồng bộ với FormModal
//     minHeight: "46px",
//     height: "46px",
//     boxShadow: state.isFocused ? "0 0 0 4px rgba(220, 38, 38, 0.1)" : "none", // Ring đỏ nhạt
//     transition: "all 0.3s ease",
//     cursor: "pointer",

//     "&:hover": {
//       borderColor: "#ef4444", // Border đỏ khi hover
//       backgroundColor: "white",
//     },

//     // Khi đang focus (click vào)
//     ...(state.isFocused && {
//       borderColor: "#dc2626", // red-600
//       backgroundColor: "white",
//     }),
//   }),

//   // 2. Tùy chỉnh container chứa chữ
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: "0 16px", // Padding-x lớn hơn cho thoáng
//     fontSize: "14px",
//     fontWeight: "500",
//     color: "#1f2937", // gray-800
//   }),

//   // 3. Tùy chỉnh từng option trong danh sách xổ xuống
//   option: (provided, state) => ({
//     ...provided,
//     padding: "10px 16px",
//     fontSize: "13px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.2s ease",
    
//     // Màu nền và màu chữ theo trạng thái
//     backgroundColor: state.isSelected
//       ? "#dc2626" // red-600 khi được chọn
//       : state.isFocused
//       ? "#fef2f2" // red-50 khi rà chuột qua
//       : "white",

//     color: state.isSelected 
//       ? "white" 
//       : state.isFocused 
//       ? "#dc2626" 
//       : "#4b5563", // gray-600

//     "&:active": {
//       backgroundColor: "#b91c1c", // red-700 khi click mạnh
//     },
//   }),

//   // 4. Tùy chỉnh bảng chọn xổ xuống (Menu)
//   menu: (provided) => ({
//     ...provided,
//     borderRadius: "1.25rem", // rounded-3xl
//     overflow: "hidden",
//     boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
//     border: "1px solid #f3f4f6",
//     padding: "4px",
//     zIndex: 9999,
//   }),

//   // 5. Tùy chỉnh danh sách bên trong menu
//   menuList: (provided) => ({
//     ...provided,
//     padding: "4px",
//     "::-webkit-scrollbar": {
//       width: "4px",
//     },
//     "::-webkit-scrollbar-track": {
//       background: "transparent",
//     },
//     "::-webkit-scrollbar-thumb": {
//       background: "#d1d5db",
//       borderRadius: "10px",
//     },
//   }),

//   // 6. Tùy chỉnh giá trị đang hiển thị
//   singleValue: (provided) => ({
//     ...provided,
//     color: "#111827", // text-gray-900
//     fontWeight: "600",
//   }),

//   // 7. Tùy chỉnh chữ gợi ý (Placeholder)
//   placeholder: (provided) => ({
//     ...provided,
//     color: "#9ca3af", // gray-400
//     fontWeight: "400",
//   }),

//   // 8. Tùy chỉnh các icon (mũi tên, nút xóa)
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     paddingRight: "8px",
//   }),

//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: state.isFocused ? "#dc2626" : "#9ca3af",
//     "&:hover": {
//       color: "#dc2626",
//     },
//   }),

//   indicatorSeparator: () => ({
//     display: "none", // Ẩn vách ngăn cho tối giản
//   }),

//   // 🔴 FIX: Luôn hiển thị trên cùng (quan trọng cho Modal/Drawer)
//   menuPortal: (base) => ({
//     ...base,
//     zIndex: 99999,
//   }),
// };

// export default customSelectStyles;
















// utils/customSelectStyles.js

const customSelectStyles = {
  // 1. Khung điều khiển (ô hiển thị chính)
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "white", // Nền trắng theo yêu cầu
    borderColor: state.isFocused ? "#dc2626" : "#e5e7eb", // Viền xám nhẹ (gray-200), đỏ khi focus
    borderWidth: "1px",
    borderRadius: "8px", // Bo góc nhẹ (khớp với Table và Input cũ)
    minHeight: "42px",
    height: "42px",
    boxShadow: state.isFocused ? "0 0 0 1px rgba(220, 38, 38, 0.1)" : "none",
    transition: "all 0.2s ease",
    cursor: "pointer",

    "&:hover": {
      borderColor: "#d1d5db", // gray-300 khi hover
    },

    // Trạng thái khi đang click vào
    ...(state.isFocused && {
      borderColor: "#dc2626", // Đỏ thương hiệu
      backgroundColor: "white",
    }),
  }),

  // 2. Nội dung bên trong (Text & Placeholder)
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 12px",
    fontSize: "14px",
    color: "#374151", // text-gray-700
  }),

  // 3. Từng lựa chọn trong danh sách xổ xuống (Options)
  option: (provided, state) => ({
    ...provided,
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: state.isSelected ? "600" : "400",
    cursor: "pointer",
    
    // Màu nền linh hoạt
    backgroundColor: state.isSelected
      ? "#dc2626" // Nền đỏ khi chọn
      : state.isFocused
      ? "#fef2f2" // Hồng rất nhạt khi di chuột
      : "white",

    color: state.isSelected 
      ? "white" 
      : state.isFocused 
      ? "#dc2626" 
      : "#374151",

    "&:active": {
      backgroundColor: "#dc2626",
      color: "white",
    },
  }),

  // 4. Bảng danh sách xổ xuống (Menu)
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px", // Đồng bộ bo góc nhẹ
    overflow: "hidden",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    border: "1px solid #e5e7eb",
    zIndex: 9999,
  }),

  // 5. Giá trị đang được hiển thị
  singleValue: (provided) => ({
    ...provided,
    color: "#111827", // text-gray-900
  }),

  // 6. Chữ gợi ý
  placeholder: (provided) => ({
    ...provided,
    color: "#9ca3af", // gray-400
  }),

  // 7. Các icon điều hướng (Mũi tên)
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#dc2626" : "#9ca3af",
    padding: "0 8px",
    "&:hover": {
      color: "#dc2626",
    },
  }),

  // Ẩn vạch ngăn cho giao diện thoáng hơn
  indicatorSeparator: () => ({
    display: "none",
  }),

  // 🔴 FIX: Hiển thị trên cùng (đặc biệt quan trọng cho Modal)
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999,
  }),
};

export default customSelectStyles;